<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Plano e cobrança</span>
        <h1>Pagamentos</h1>
        <p>Acompanhe o uso contratado, a forma de pagamento e o histórico de cobranças.</p>
      </div>
    </header>

    <CheckoutContent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CheckoutContent from "../../components/Payment/PaymentContent.vue";

export default defineComponent({
  name: "PaymentPage",
  components: {
    CheckoutContent,
  },
});
</script>
